import "./Textarea.css";
import classNames from "classnames";
import { forwardRef, FunctionComponent, SVGProps, TextareaHTMLAttributes, useId } from "react";
import { ReactComponent as ErrorIcon } from "@icons/error.svg";
import { ReactNode } from "react";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  icon?: ReactNode;
  label?: string;
  helperText?: string;
  state?: "error";
  className?: string;
  suffix?: string;
  prefix?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ icon, className, label, helperText, state, id, suffix, prefix, ...props }, ref) => {
    const generatedId = useId();
    const finalId = id ?? generatedId;

    let stateClasses = "";
    let MessageIcon: FunctionComponent<SVGProps<SVGSVGElement>> | null = null;

    switch (state) {
      case "error":
        stateClasses = "outline outline-2 outline-brand-red focus:outline-brand-red";
        MessageIcon = ErrorIcon;
        break;
    }

    return (
      <div className="relative space-y-1">
        {label && (
          <label aria-describedby={`aria-${finalId}`} className="font-bold text-navy-blue text-base" htmlFor={finalId}>
            {label}
          </label>
        )}

        <textarea
          ref={ref}
          id={finalId}
          className={classNames(
            "wisdom-textarea block resize-none mt-1 appearance-none h-[200px] w-full bg-l-blue text-navy-blue placeholder:font-bold font-bold focus:outline-brand-purple placeholder:text-navy-blue-bright rounded-[6px] p-4",
            stateClasses,
            className
          )}
          {...props}
        />

        {helperText && (
          <div className="flex items-center mt-2">
            {MessageIcon && <MessageIcon width={16} height={18} />}
            <p id={`aria-${finalId}`} className="pl-1 text-sm">
              {helperText}
            </p>
          </div>
        )}
      </div>
    );
  }
);
